module.exports = __webpack_public_path__ + "img/logo-capistrano-interior.311abf5f.png";